import {
  mdiPlusCircle,
  mdiPencil,
  mdiDelete,
  mdiNoteOutline,
  mdiPaperclip,
  mdiTagText,
  mdiTextBox,
  mdiAccountCircle,
  mdiEye,
  mdiLock,
  mdiAlert,
  mdiInformation,
  mdiCheckCircle,
  mdiExclamation
} from '@mdi/js'

export default {
  'freshvuenotes-add': mdiPlusCircle,
  'freshvuenotes-edit': mdiPencil,
  'freshvuenotes-delete': mdiDelete,
  'freshvuenotes-show-notes': mdiNoteOutline,
  'freshvuenotes-show-attachments': mdiPaperclip,

  'freshvuenotes-title': mdiTagText,
  'freshvuenotes-description': mdiTextBox,

  'freshvuenotes-filter-user': mdiAccountCircle,
  'freshvuenotes-filter-file': mdiPaperclip,

  'freshvuenotes-visibility-public': mdiEye,
  'freshvuenotes-visibility-private': mdiLock,

  'freshvuenotes-severity-icon': mdiAlert,
  'freshvuenotes-severity-NONE': mdiNoteOutline,
  'freshvuenotes-severity-INFO': mdiInformation,
  'freshvuenotes-severity-SUCCESS': mdiCheckCircle,
  'freshvuenotes-severity-WARNING': mdiExclamation,
  'freshvuenotes-severity-ERROR': mdiAlert
}
